import { useLanguageStore } from "@/stores/useLanguageStore"; 
import type { Pinia } from "pinia";
import type { AppI18n } from '@/i18n';

export const supportedLanguages = ['de', 'en'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

export const languageLabels: Record<SupportedLanguage, string> = {
  en: 'EN',
  de: 'DE',
};

const defaultLanguage: SupportedLanguage = 'de';

export function initializeLanguage(pinia: Pinia, i18n: AppI18n) {
  const languageStore = useLanguageStore(pinia); 
  let savedLanguage = localStorage.getItem('preferredLanguage') as SupportedLanguage | null;

  if (!savedLanguage || !supportedLanguages.includes(savedLanguage)) {
    savedLanguage = defaultLanguage;
  }

  languageStore.setLanguage(savedLanguage);
  i18n.global.locale.value = savedLanguage;
}
